// Scrolls. A side holds as many as its caster has scroll slots. A scroll
// comes from a face of the die or from a spell, at random from the list.

import { casterById, SCROLLS } from '../content/casters';
import { livingCasterIds } from '../engine/roles';
import type { Side } from '../engine/types';
import type { GameState } from '../game/state';
import type { Rng } from '../lib/rng';
import { isFuseLit } from './helpers';
import type { SpellId } from './types';

/** The scroll slots of the side with no scroll in them. Zero in a match with no casters. */
export const openScrollSlots = (state: GameState, side: Side): number => {
  if (!state.casters) return 0;
  // A caster with no living piece has no scroll slot.
  const living = livingCasterIds(state.board, side);
  const slots = state.casters[side].reduce(
    (sum, id) => sum + (living.has(id) ? casterById(id).scrollSlots : 0),
    0,
  );
  return Math.max(0, slots - state.scrolls[side].length);
};

/** The scrolls in the draw now. `defuse-bomb` is one of them only while a fuse is lit. */
export const scrollBasket = (state: GameState): SpellId[] =>
  SCROLLS.filter((id) => id !== 'defuse-bomb' || isFuseLit(state.board));

/** Puts a random scroll in an open slot of the side. The scroll is null when no slot is open. */
export const gainScroll = (
  state: GameState,
  side: Side,
  rng: Rng,
): { state: GameState; scroll: SpellId | null } => {
  if (openScrollSlots(state, side) <= 0) return { state, scroll: null };
  const scroll = rng.pick(scrollBasket(state));
  const scrolls = { ...state.scrolls, [side]: [...state.scrolls[side], scroll] };
  return { state: { ...state, scrolls }, scroll };
};
